import { User, FileText, BarChart2, X, Trash, Search } from 'react-feather';
import { ReactComponent as Roles } from '../../assets/images/icons/roles_active.svg';
import { ReactComponent as Finger } from '../../assets/images/icons/ico_fichas.svg';

export default [
	{
		id: 'users',
		title: 'Usuarios',
		icon: <User size={20} />,
		navLink: '/users'
	},
	{
		id: 'rolesPermissions',
		title: 'Roles y Permisos',
		icon: <Roles size={20} />,
		navLink: '/roles'
	},
	{
		id: 'fichasActivas',
		title: 'Fichas Activas',
		icon: <Finger size={20} />,
		navLink: '/fichas_activas'
	},
	{
		id: 'fichasCanceladas',
		title: 'Fichas Canceladas',
		icon: <X size={20} />,
		navLink: '/fichas_canceladas'
	},
	{
		id: 'fichasEliminadas',
		title: 'Fichas Eliminadas',
		icon: <Trash size={20} />,
		navLink: '/fichas_eliminadas'
	},
	{
		id: 'consultaFichas',
		title: 'Consulta de Fichas',
		icon: <Search style={{ width: '18px' }} />,
		navLink: '/consulta_fichas'
	},
	{
		id: 'registers',
		title: 'Registros',
		icon: <FileText size={20} />,
		navLink: ''
	},
	{
		id: 'modulos',
		title: 'Modulos',
		icon: <Search style={{ width: '18px' }} />,
		navLink: '/modulos',
		resource: 'modulos',
		action: 'show'
	},
	{
		id: 'reports',
		title: 'Reportes',
		icon: <BarChart2 size={20} />,
		navLink: ''
	}
];
